<template>
	<div class="idx_wrap clearfix">
		<div class="workbench">
			<div class="card">
				<div class="card-header" style="background: none; font-size: 20px; font-weight: bold;">保险箱</div>
				<div class="card-body">
					<!-- 1 -->
					<div class="clearfix">
						<div class="row">
							<div class="col">
								<!-- 注册统计 -->
								<div class="card mr-2">
									<div class="card-header">
										<span class="float-left">保险箱总览</span>
									</div>
									<div class="card-body" style="padding: 1.25rem 0;">
										<div class="d-flex bd-highlight text-center" style="height: 120px;">
											<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
												<div>总赏金</div>
												<h3 class="mt-4">{{walletInfor.total_fund}}</h3>
											</div>
											<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
												<div>实收赏金</div>
												<h3 class="mt-4">{{walletInfor.withdraw_fund}}</h3>
											</div>
											<div class="flex-fill bd-highlight">
												<div>可提现赏金</div>
												<h3 class="mt-4">{{walletInfor.fund}}</h3>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col">
								<!-- 财务统计 -->
								<div class="card">
									<div class="card-header">
										<span class="float-left">银行卡设置</span>
									</div>
									<div class="card-body" style="padding: 1.25rem 0;">
										<div class="d-flex bd-highlight" style="height: 120px;">
											<div class="flex-fill bd-highlight">
												<div class="ml-4">收款银行卡</div>
												<h3 class="mt-4 float-left ml-4">{{walletInfor.bank_name}}</h3>
												<h3 class="mt-4 float-left ml-5">尾号（{{walletInfor.bank_card_no_end}}）</h3>
											</div>
											<!-- <div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
												<div>本季度收入</div>
												<h3 class="mt-4">20000</h3>
											</div>
											<div class="flex-fill bd-highlight">
												<div>总收入</div>
												<h3 class="mt-4">300000</h3>
											</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 2 -->
					
					<div class="row mt-3">
						<div class="col">
							<!-- 注册统计 -->
							<div class="card">
								<div class="card-header">
									<span class="float-left">我要提现</span>
								</div>
								<div class="card-body" style="padding: 1.25rem 0 2.5rem;">
									<el-col :span="14">
										<div class="float-left ml-5">
											<div class="mt-4 mb-4">提现金额</div>
											<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
												<div class="clearfix">
													<div v-if="iSmoney" style="margin-left: 30px; margin-bottom: 10px; color: #F56C6C; font-size: 14px;">提现金额大于您可提现的总金额了!</div>
													<div class="float-left">
														<h1 class="float-left" style=" line-height: 33px; width: 30px;">¥</h1>
														<div class="float-left mr-3" style="width: 220px;">
															<el-form-item prop="money">
															    <el-input placeholder="请输入金额, 最少提现100元" class="float-left" v-model="ruleForm.money"></el-input>
															</el-form-item>
														</div>
														<div class="float-left" style="line-height: 40px;" v-if="actualMoney">实际到账 : {{actualMoney}} 元</div>
													</div>
													<div class="float-left">
														<h1 class="float-left" style=" line-height: 33px; width: 30px;"></h1>
														<div class="float-left mr-3" style="width: 220px;">
															<el-form-item prop="code">
															    <el-input  v-model="ruleForm.code" placeholder="请输入验证码" class="float-left"></el-input>
															</el-form-item>
														</div>
														<!-- <el-button plain >获取验证码</el-button> -->
														<el-tooltip class="item" effect="dark" :content="tip" placement="right-start">
														  <el-button @click="get_code_btn">发送验证码</el-button>
														</el-tooltip>
													</div>
													<div style="clear: both;"></div>
												</div>
												<el-button type="primary" style="margin-left: 30px; margin-top: 0 !important;" @click="submitForm('ruleForm')">申请提现</el-button>
											</el-form>
										</div>
										
									</el-col>
								    <el-col :span="10">
										<div class="float-left p-3">
											T+1结算 星期六日节假日除外
											申请提现后交易日的次日。
											T就是today （今天的意思）的第一个字母的大写，T+1，T+2就是从今天算起1天或2天的意思，这里T是指工作天（即星期六日节假日除外）。
											
											提现均为税后结算
										</div>
									</el-col>
									
									
									<!-- <div class="d-flex bd-highlight text-center" style="height: 120px;">
										<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
											<div>应收赏金</div>
											<h3 class="mt-4">2000</h3>
										</div>
										<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
											<div>实收赏金</div>
											<h3 class="mt-4">3800</h3>
										</div>
										<div class="flex-fill bd-highlight">
											<div>可提现赏金</div>
											<h3 class="mt-4">350</h3>
										</div>
									</div> -->
								</div>
							</div>
						</div>
					</div>
	
					<!-- 用户列表 -->
					<div class="demo-block">
						<el-table :data="withdrawList_data" style="width: 100%">
							<el-table-column label="提现订单号" width="200" align="center">
								<template slot-scope="scope">
									<div>{{ scope.row.order_no }}</div>
								</template>
							</el-table-column>
							<el-table-column label="提现赏金(税后)" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.money_text }}</span>
								</template>
							</el-table-column>
							<el-table-column label="提现手续费" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.rate_text }}</span>
								</template>
							</el-table-column>
							<el-table-column label="申请日期" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.time }}</span>
								</template>
							</el-table-column>
							<el-table-column label="提现状态" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.status_text }}</span>
								</template>
							</el-table-column>
							<el-table-column fixed="right" label="操作" width="100" align="center">
								<template slot-scope="scope">
									<el-button type="text" @click="withdrawDetails(scope.row,$event)" size="small">查看</el-button>
								</template>
							</el-table-column>
							 <!-- @click="handleClick(scope.row)" -->
							
						</el-table>
					</div>
					<!-- 用户列表 -->
	
					<!-- 分页 -->
					<pading :help="help_num" :currentPage = "currentPage" :pageSize="pageSize" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pading>
					<!-- 分页 -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { myWallet, withdrawList, Send, applyWithdraw  } from '../../common/api/http.js'
	import {
		mapState
	} from 'vuex'
	import Pading from '../../components/paging/index.vue' //分页组件
	export default{
		components:{
			Pading
		},
		data(){
			return{
				ruleForm: {
				  money: '',
				  code: ''
				},
				rules: {
					money: [
						{ required: true, message: '请输入提现金额', trigger: 'change' }
					],
					code: [
						{ required: true, message: '请输入验证码', trigger: 'change' }
					]
				},
				tip:'',
				walletInfor:'',//钱包信息
				actualMoney:'',//实际提现的金额
				iSmoney:false, //提现金额是否大于可提现的金额
				withdrawList_data: [],//提现列表
				
				help_num: 1,//总共多少条内容 默认1
				currentPage:1, //当前页的index
				pageSize:10, //每页显示多少条
			}
		},
		mounted() {
			// 钱包信息
			this.walletData()
			// 钱包信息
			
			this.tip = '短信会发送至您的'+this.user.mobile.substr(this.user.mobile.length-4)+'尾号上'
			
			// 提现列表
			this.withdrawList_fn()
			// 提现列表
		},
		computed: {
			...mapState({
				user: state => state.user.user
			})
		},
		methods:{
			// 获取验证码
			get_code_btn(){
				// 提前验证是否输入提现金额
				this.$refs.ruleForm.validateField("money", errMsg => {
				  if (errMsg) {
				    console.log("校验未通过");
					
				  } else {
				    console.log("校验通过");
					
					this.actualMoney=parseInt(this.ruleForm.money)-(this.ruleForm.money*60)/10000 //实际提现的金额
					
					if(this.actualMoney>this.walletInfor.total_fund){
						this.$message.error('提现金额大于您可提现的总金额了!');
						this.iSmoney = true
					}else{
						// 获取验证码
						let data = {
							'mobile':this.user.mobile,
							'action':'4'
						}
						Send(data).then(res => {
							console.log(res)
							if(res.code == 0){
								this.$message({
								  message: '验证码发送成功!',
								  type: 'success'
								});
								this.$message(res.data.code)
							}else{
								this.$message.error(res.msg);
							}
							
						}).catch(err => {
							console.log(err)
						})
					}
					
				  }
				});
				
			},
			// 申请提现
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					// 验证成功-申请提现
					let token = window.sessionStorage.getItem('token')
					let data = {
						'api_token':token,
						'sms_code':this.ruleForm.code,
						'money':this.ruleForm.money*100
					}
					console.log(data)
					applyWithdraw(data).then(res => {
						console.log(res)
						if(res.code == 0){
							this.$message({
							  message: '提现成功!',
							  type: 'success'
							});
							
							// 提现列表
							this.withdrawList_fn()
							// 提现列表
							
							// 钱包信息
							this.walletData()
							// 钱包信息
							
						}else{
							this.$message.error(res.msg);
							
							//清空
							this.ruleForm.money = ''
							this.ruleForm.code = ''
							this.actualMoney = ''
						}
						
					}).catch(err => {
						console.log(err)
					})
				  } else {
					// console.log('error submit!!');
					return false;
				  }
				});
			},
			// 每页显示条数 10，20，50，100
			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.pageSize = val
				this.withdrawList_fn()
			},
			//当前页的index
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.currentPage = val
				this.withdrawList_fn()
			},
			// 提现--查看详情 
			withdrawDetails(e,evt){
				console.log(e.id)
				this.$router.push({
					name: 'safe_withdrawAudit',
					query: {withdraw_id: e.id}
				})
			},
			// 提现列表
			withdrawList_fn(){
				let token = window.sessionStorage.getItem('token')
				let data = {
					'api_token':token,
					'page':this.currentPage,
					'page_size':this.pageSize
				}
				withdrawList(data).then(res => {
					console.log(res)
					if(res.code == 0){
						this.withdrawList_data = res.data.withdraw_list
					}else{
						this.$message.error(res.msg);
					}
					
				}).catch(err => {
					console.log(err)
				})
			},
			//钱包信息
			walletData(){
				let token = window.sessionStorage.getItem('token')
				let data = {
					'api_token':token,
				}
				myWallet(data).then(res => {
					console.log(res)
					if(res.code == 0){
						this.walletInfor = res.data
					}else{
						
					}
					
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>
</style>
